import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import UploadPage from './pages/UploadPage';
import EvaluationPage from './pages/EvaluationPage';
import ReportPage from './pages/ReportPage';
import ReportsListPage from './pages/ReportsListPage';
import RolesPage from './pages/RolesPage';
import RoleCreatePage from './pages/RoleCreatePage';
import RoleUploadPage from './pages/RoleUploadPage';
import SettingsPage from './pages/SettingsPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Header />
                <main className="container mx-auto px-4 py-8 flex-grow">
                  <UploadPage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="/evaluation/:batchId" element={
              <ProtectedRoute>
                <Header />
                <main className="container mx-auto px-4 py-8 flex-grow">
                  <EvaluationPage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="/report/:batchId" element={
              <ProtectedRoute>
                <Header />
                <main className="w-full max-w-none px-4 sm:px-6 lg:px-8 py-8 flex-grow">
                  <ReportPage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute>
                <Header />
                <main className="container mx-auto px-4 py-8 flex-grow">
                  <ReportsListPage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="/roles" element={
              <ProtectedRoute>
                <Header />
                <main className="container mx-auto px-4 py-8 flex-grow">
                  <RolesPage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="/roles/create" element={
              <ProtectedRoute>
                <Header />
                <main className="container mx-auto px-4 py-8 flex-grow">
                  <RoleCreatePage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="/evaluation/new/:roleId" element={
              <ProtectedRoute>
                <Header />
                <main className="container mx-auto px-4 py-8 flex-grow">
                  <RoleUploadPage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Header />
                <main className="container mx-auto px-4 py-8 flex-grow">
                  <SettingsPage />
                </main>
                <Footer />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
